export default __webpack_public_path__ + "fonts/b9d2753f9c6eb640c4c95e8009e69f94.ttf";